import React from "react";

const SixCareersHighlights = () => {
  return (
    <section className="events-page-landing-section events-page-landing-section-space events-page-careers-section-highlight">
      <div className="events6ix-layout-page-middle">
        <div className="events-page-careers-section-highlight-row">
          <div className="events-page-careers-section-highlight-row-col">
            <div className="events-page-careers-section-header-heading">
              What We Look For
            </div>
          </div>

          <div className="events-page-careers-section-highlight-row-col">
            <div className="events-page-careers-section-highlight-row-col-list mt-0">
              <div className="events-page-careers-section-at-row-col-list-heading">
                Passionate Builders
              </div>
              <div className="events-page-careers-section-highlight-row-col-list-text">
                "Live for a time like others won't for a chance to live forever
                like others can't." We seek individuals ready to do the best
                work of their career and push beyond limits.
              </div>
            </div>

            <div className="events-page-careers-section-highlight-row-col-list">
              <div className="events-page-careers-section-at-row-col-list-heading">
                Ownership Mentality
              </div>
              <div className="events-page-careers-section-highlight-row-col-list-text">
                Take pride in your work and how it shapes your identity. Own
                your functional area and drive results that matter.
              </div>
            </div>

            <div className="events-page-careers-section-highlight-row-col-list">
              <div className="events-page-careers-section-at-row-col-list-heading">
                Leadership Without Limits
              </div>
              <div className="events-page-careers-section-highlight-row-col-list-text">
                We're building the future of global investing, and we need
                future leaders. Our comprehensive Leadership Development program
                is designed to unlock your full potential, preparing you to lead
                in a rapidly evolving financial landscape.
              </div>
            </div>
          </div>
          <div className="events-page-careers-section-highlight-row-col">
            <div className="events-page-careers-section-highlight-row-col-list mt-0">
              <div className="events-page-careers-section-at-row-col-list-heading">
                Problem Solvers
              </div>
              <div className="events-page-careers-section-highlight-row-col-list-text">
                Be obsessed with the challenges we're trying to solve. Bring
                your best ideas forward and help them win through collaborative
                execution.
              </div>
            </div>

            <div className="events-page-careers-section-highlight-row-col-list">
              <div className="events-page-careers-section-at-row-col-list-heading">
                Cross-Functional Collaboration
              </div>
              <div className="events-page-careers-section-highlight-row-col-list-text">
                In our fast-paced, innovative environment, you'll have the
                opportunity to work across teams, gaining exposure to all
                aspects of our platform.
              </div>
            </div>

            <div className="events-page-careers-section-highlight-row-col-list">
              <div className="events-page-careers-section-at-row-col-list-heading">
                Mission Alignment
              </div>
              <div className="events-page-careers-section-highlight-row-col-list-text">
                Join us only if you believe in our mission to democratize global
                investing and are excited to play a role in this transformation.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SixCareersHighlights;
